// STLEmployeeLogin.js
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import './Login.css';


const api = axios.create({ baseURL: 'https://django-backend-115705416374.asia-south1.run.app' });
// const api = axios.create({ baseURL: 'http://localhost:8000' });

export default function STLEmployeeLogin({ onShowRegister, setSelected }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const res = await api.post('api/google-login/google-oauth2/', {
        token: credentialResponse.credential,
      });

      // Store tokens
      if (res.data.access) localStorage.setItem('access', res.data.access);
      if (res.data.refresh) localStorage.setItem('refresh', res.data.refresh);

      // Check email domain for STL users
      const userEmail = res.data.email || '';
      const emailDomain = res.data.email_domain || '';

      const isStl =
        userEmail.toLowerCase().endsWith('@stl.tech') ||
        userEmail.toLowerCase().endsWith('@stltech.in') ||
        emailDomain.toLowerCase() === 'stl.tech' ||
        emailDomain.toLowerCase() === 'stltech.in';

      localStorage.setItem('landing', 'admin');
      window.location.reload();
    } catch (err) {
      setIsLoading(false);
      // Google login error
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: err.response?.data?.error || 'Google login failed.',
      });
    }
  };

  return (
    <div className="auth-box">
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader-popup">
            <div className="spinner"></div>
            <div className="loading-text">Please wait... Logging you in</div>
          </div>
        </div>
      )}
      <div className="logos-container">
        <img draggable={false}
          src={process.env.PUBLIC_URL + "/Main.png"}
          alt="Main Logo"
          className="logo"
        />
        <img draggable={false}
          src={process.env.PUBLIC_URL + "/Invenia.png"}
          alt="Invenia Logo"
          className="logo logo-second"
        />
        <img draggable={false}
          src={process.env.PUBLIC_URL + "/STL_Logo.png"}
          alt="STL Logo"
          className="logo logo-third"
        />
      </div>

      <h2 className="page-title">STL Employee Login</h2>

      <div className="google-login-container">
        <GoogleOAuthProvider clientId="142524981824-4mrc83kdgpndreai60aiiapcijbk6f28.apps.googleusercontent.com">
          <GoogleLogin
            onSuccess={handleGoogleLoginSuccess}
            onError={() =>
              Swal.fire({
                icon: 'error',
                title: 'Login Failed',
                text: 'Google login failed.',
              })
            }
            text="signin_with"
            shape="rectangular"
            size="large"
            theme="outline"
            logo_alignment="left"
            auto_select={false}
            useOneTap={false}
            ux_mode="popup"
            prompt="select_account"
          />
        </GoogleOAuthProvider>
      </div>

      {/* <p>
        Don’t have an account?{' '}
        <button className="link-btn" onClick={onShowRegister}>
          Register
        </button>
      </p> */}

      {/* ✅ Back Button — safely uses setSelected */}
      {setSelected && (
        <button className="back-btn" onClick={() => setSelected(null)}>
          Back
        </button>
      )}

      <div style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0', zIndex: 1000 }}>
        <span style={{ fontWeight: '600', color: '#fff', marginRight: '10px' }}>Powered by</span>
        <img draggable={false} src="/Main.png" alt="STL-DIGITAL" style={{ height: '30px' }} />
      </div>
    </div>
  );
}


